import React from "react";
import { Grid, useMediaQuery } from "@mui/material";
import { makeStyles, useTheme } from "@mui/styles";
import Carousel from "react-material-ui-carousel";
import CarouselReviewItem from "bundles/Main/components/CarouselReviewItem";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import Malena from "images/LandingPage/scaled/malena_1280.webp";
import Caterina from "images/LandingPage/scaled/caterina_1280.webp";
import Dimitra from "images/LandingPage/scaled/dimitra_1280.webp";
import Heloise from "images/LandingPage/scaled/heloise_1280.webp";
import Caroline from "images/LandingPage/scaled/caroline_1280.webp";
import Eleni from "images/LandingPage/scaled/eleni_1280.webp";
import Athanasia from "images/LandingPage/scaled/athanasia_1280.webp";
import Marina from "images/LandingPage/scaled/marina_1280.webp";
import Eva from "images/LandingPage/scaled/eva_1280.webp";
import Konstantinos from "images/LandingPage/scaled/konstantinos_1280.webp";
import Yasmeen from "images/LandingPage/scaled/yasmeen_1280.webp";
import Alberto from "images/LandingPage/scaled/alberto_1280.webp";
import Kenya from "images/LandingPage/scaled/kenya_1280.webp";
import Angelina from "images/LandingPage/scaled/angelina_1280.webp";
import Michael from "images/LandingPage/scaled/michael_1280.webp";
import Edouard from "images/LandingPage/scaled/edouard_1280.webp";
import Juliette from "images/LandingPage/scaled/juliette_1280.webp";
import Maria from "images/LandingPage/scaled/maria_1280.webp";
import Iro from "images/LandingPage/scaled/iro_1280.webp";
import Rayhan from "images/LandingPage/scaled/rayhan_1280.webp";
import Klara from "images/LandingPage/scaled/klara_1280.webp";
import Jesse from "images/LandingPage/scaled/jesse_1280.webp";
import Yannic from "images/LandingPage/scaled/yannic_1280.webp";
import Nathan from "images/LandingPage/scaled/nathan_1280.webp";
import Maria2 from "images/LandingPage/scaled/maria_2_1280.webp";
import Jad from "images/LandingPage/scaled/jad_1280.webp";
import Steve from "images/LandingPage/scaled/steve_1280.webp";
import ReviewerPlaceholder from "images/reviewer-placeholder.svg";

const useStyles = makeStyles((theme) => ({
  carouselGrid: {
    margin: "24px 0px !important",
    maxWidth: "100%",
    overflowX: "hidden",
  },
  avatar: {
    width: theme.spacing(35),
    height: theme.spacing(35),
  },
  reverseGrid: {
    flexDirection: "row-reverse",
  },
}));

const reviewTimestamp = (review) => {
  const ts = Date.parse(`${review.date} 1`);
  return Number.isNaN(ts) ? 0 : ts;
};

const reviewSectorTags = (review) => review.fields ?? [review.field];

const matchesFilter = (review, filterField) => {
  if (filterField == null) return true;
  const filters = Array.isArray(filterField) ? filterField : [filterField];
  const tags = reviewSectorTags(review);
  return filters.some((f) => tags.includes(f));
};

const ReviewsCarousel = ({ filterField = null }) => {
  const classes = useStyles();
  const theme = useTheme();

  const allReviews = [
    {
      key: 1,
      text: "Tanzania is the perfect place to start your discovery of Africa, and HealthMission is the ideal organization to structure your medical adventure. I spent two months in Arusha doing clinical training in busy hospitals, where I practiced hands-on medicine under supervision. The staff at Mount Meru were patient and supportive, and the comfortable house and delicious meals balanced the intense medical experience. I highly recommend HealthMission Africa for anyone looking to broaden their horizons and enhance their healthcare skills.",
      name: "Malena Grau",
      date: "April 2024",
      position: "5th year medical student",
      picture: Malena,
      picturesmall: Malena,
      alt: "",
      field: "medical",
    },
    {
      key: 2,
      text: "HealthMission Africa... Where do I start? My 22 days were amazing and unforgettable, but not long enough. The hospital felt like home with welcoming people and safe, beautiful accommodation. The food was tasty, and the security was excellent. Thank you for helping me pursue my dreams and providing a place to heal and reconnect. In just three weeks, I gained incredible knowledge and experience that I couldn't have imagined. Nakupenda Tanzania. Asante Sana.",
      name: "Caterina Alves",
      date: "January 2024",
      position: "4th year nursing student",
      picture: Caterina,
      picturesmall: Caterina,
      alt: "",
      field: "medical",
    },
    {
      key: 3,
      text: "I wholeheartedly recommend HealthMission Africa for medical students. Based in Arusha, Tanzania, this program offers an enriching blend of hands-on medical practice and cultural immersion. During my time at Arusha Hospital, I gained invaluable medical experience, supported by the incredibly kind and passionate staff who made us feel at home. The beauty of Tanzania’s landscapes added to the transformative experience, making it truly unforgettable. This program not only enhances medical skills but also opens your heart to the warmth and hospitality of the Tanzanian people.",
      name: "Dimitra Papagelopoulos",
      date: "July 2023",
      position: "4th year Medical Student",
      picture: Dimitra,
      picturesmall: Dimitra,
      alt: "",
      field: "medical",
    },
    {
      key: 5,
      text: "My adventure with HealthMission was heartwarming. The experience that I will never forget has taught me enormously, both medically and non-medically. Thanks to HealthMission we had the opportunity to contribute a lot to the hospital and also to feel at home in Arusha. The contacts on site have a place in my heart. I will return next year with more medical knowledge to have an even greater impact! I’m very thankful for all the opportunities.",
      name: "Héloïse Couronné",
      date: "September 2023",
      position: "3rd year medical student",
      picture: Heloise,
      picturesmall: Heloise,
      alt: "",
      field: "medical",
    },
    {
      key: 6,
      text: "My two-month clinical training in Tanzania with HealthMission Africa was extraordinary. Based in Arusha, I trained in Pediatrics, Dermatology, and Emergency Medicine at Mount Meru Hospital, where the supportive staff helped me improve my skills. Comfortable accommodations and delicious meals made the intense days manageable. HealthMission Africa also organized amazing excursions to explore Tanzania's beauty. I highly recommend HealthMission Africa for a transformative experience that broadens horizons and enhances medical skills.",
      name: "Caroline Sommerfeld",
      date: "March 2024",
      position: "5th year Medical Student",
      picture: Caroline,
      picturesmall: Caroline,
      alt: "",
      field: "medical",
    },
    {
      key: 7,
      text: "My time with HealthMission Africa in Arusha was truly eye-opening and left a lasting impact on my view of medicine and the world. The internship allowed us to learn and contribute meaningfully to the community through hands-on medical procedures and patient interactions. Adapting to Tanzania's unique healthcare environment was inspiring, broadening my medical knowledge and boosting my confidence. This experience ignited my passion for compassionate healthcare and personal growth. If you're seeking a meaningful volunteering experience, I highly recommend HealthMission Africa.",
      name: "Eleni Vissaraki",
      date: "July 2023",
      position: "Medical Doctor",
      picture: Eleni,
      picturesmall: Eleni,
      alt: "",
      field: "medical",
    },
    {
      key: 8,
      text: "Volunteering in Tanzania was truly a life-changing experience. The warmth and hospitality of the people made me feel like part of the community from day one. Working alongside such inspiring individuals to make a difference in the lives of others was both humbling and rewarding. The breathtaking landscapes, vibrant culture, and unforgettable connections I made have left an indelible mark on my heart. This journey has not only broadened my perspective but has also taught me the true meaning of community and compassion. I'll carry these memories with me for a lifetime.",
      name: "Athanasia Margariti",
      date: "July 2024",
      position: "4th year medical student, European University of Cyprus",
      picture: Athanasia,
      picturesmall: Athanasia,
      alt: "",
      field: "medical",
    },
    {
      key: 9,
      text: "The people of Arusha welcomed me with open hearts. Their resilience and hope taught me more about medicine and life than any classroom ever could. It was an amazing experience and I would definitely do it again.",
      name: "Marina Aletrari",
      date: "July 2025",
      position: "5th year medical student, European University of Cyprus",
      picture: Marina,
      picturesmall: Marina,
      alt: "",
      imagePosition: "top",
      field: "medical",
    },
    {
      key: 10,
      text: "Being immersed in such a different environment made me grow in ways I didn’t expect. I came back more confident, grateful, and motivated.",
      name: "Eva Devresse",
      date: "June 2025",
      position: "4th year medical student, Université Libre de Bruxelles, Belgium",
      picture: Eva,
      picturesmall: Eva,
      alt: "",
      imagePosition: "top",
      field: "medical",
    },
    {
      key: 11,
      text: "My clinical internship in Tanzania has been an incredibly valuable experience, offering me the opportunity to learn, grow, and contribute in a meaningful way.",
      name: "Konstantinos Mouratides",
      date: "July 2025",
      position: "4th year medical student, University of Ioannina, Greece",
      picture: Konstantinos,
      picturesmall: Konstantinos,
      alt: "",
      field: "medical",
    },
    {
      key: 12,
      text: "Working in Tanzania was unlike any internship I’ve ever experienced—eye-opening, humbling, and profoundly human. For the first time as a student, I felt that what I did truly made a difference, reminding me why I chose a career in medicine. It was the perfect blend of clinical medicine and travel, where I met incredible people and experienced a culture that was so beautiful, welcoming, and full of life.",
      name: "Yasmeen Yousef",
      date: "July 2025",
      position: "5th year medical student, University of Nicosia, Cyprus",
      picture: Yasmeen,
      picturesmall: Yasmeen,
      alt: "",
      field: "medical",
    },
    {
      key: 13,
      text: "If you are an eager student seeking hands-on clinical experience in a beautiful country, Health Mission Africa is the perfect opportunity. At Mount Meru Regional Hospital, I gained invaluable practical skills, received excellent teaching from dedicated doctors, and learned the importance of relying on clinical knowledge and personal skills in a resource-limited setting.",
      name: "Alberto Faccenda",
      date: "July 2025",
      position: "5th year medical student, University of Nicosia, Cyprus",
      picture: Alberto,
      picturesmall: Alberto,
      alt: "",
      imagePosition: "top",
      field: "medical",
    },
    {
      key: 14,
      text: "My trip to Tanzania with Health Mission Africa was an incredibly enriching experience, both culturally and professionally. I had the opportunity to discover a completely new culture and gain a deeper understanding of daily life there, which was extremely rewarding. From a professional perspective, I was able to practice dentistry at Arusha Hospital, encounter clinical cases we don’t usually see, and most importantly help people by providing care. The hospital staff was very kind, welcoming, and supportive throughout the experience. The program was well organized from start to finish, and the team was always available when needed, which made the whole experience very reassuring. I would highly recommend this program.",
      name: "Kenya Joachimovicz",
      date: "July 2024",
      position: "4th year dentistry student, Universidad Europea de Madrid, Spain",
      picture: Kenya,
      picturesmall: Kenya,
      alt: "",
      field: "dentistry",
    },
    {
      key: 15,
      text: "Participating in HealthMission Africa in Tanzania as one of the first volunteer pharmacists was a truly meaningful and formative experience. As a pharmacist, I was entrusted with responsibility and encouraged to apply my knowledge in patient care, medication management, and health education within a low-resource environment. HealthMission Africa stands out for its ethical approach, cultural sensitivity, and commitment to sustainable healthcare impact. The organization provided excellent support throughout the program, creating a safe, well-structured, and educational experience. This volunteering experience strengthened my clinical perspective, adaptability, and motivation to pursue a career with a strong global health focus.",
      name: "Angelina Fourtouna",
      date: "July 2024",
      position: "4th year Pharmacy student, European University of Cyprus",
      picture: Angelina,
      picturesmall: Angelina,
      alt: "",
      field: "pharmacy",
    },
    {
      key: 16,
      text: "Volunteering in Tanzania with HealthMission Africa was a truly unique experience. As an experienced medic and trainer, I was able to learn a lot while also contributing meaningfully to both outreach projects and hospital work. I was exposed to a high number of traumatic injuries and acute cases, which were challenging and very enriching clinically. The support provided by HMA was excellent: the accommodation was comfortable, the food was great, and I always felt safe. I also met people from different backgrounds and countries and built genuine connections through this shared experience. I stayed for about three weeks but wish I could have stayed longer, and I would definitely return when the opportunity presents. I already miss the place. I highly recommend this experience to medical students, doctors, medics, nurses, and other healthcare professionals seeking a meaningful volunteering experience. Many thanks to HealthMission Africa for this unforgettable experience!",
      name: "Michael Vakhrushev",
      date: "October 2025",
      position: "EMS / Medic, Israel",
      picture: Michael,
      picturesmall: Michael,
      alt: "",
      field: "medical",
    },
    {
      key: 17,
      text: "It was an amazing experience, Arusha is emotionally intense and the people there are really kind. The HMA team is young, nice and dynamic and it was a pleasure working and meeting them. Also the mix of cultures in the house makes a great difference. Thanks a lot.",
      name: "Edouard Touati",
      date: "July 2025",
      position: "4th year dentistry student, Universidad Europea de Madrid, Spain",
      picture: Edouard,
      picturesmall: Edouard,
      alt: "Edouard Touati",
      imagePosition: "top",
      field: "dentistry",
    },
    {
      key: 18,
      text: "HealthMission Africa is much more than a humanitarian mission. It all starts with the excellent organization and management of accommodation, transportation, and activities. Greg, Noel, and Alex are each kinder than the next and always make sure that everything runs smoothly. They take great care of everyone at all times. When it comes to the humanitarian mission itself, both on a professional and a human level, it is an incredibly powerful experience. The connection with the patients, as well as the mutual support and camaraderie among the volunteers, are undoubtedly the most beautiful aspects I will take away from this adventure. Thank you for an experience that has left a forever mark on me, and see you very soon for new adventures ❤️",
      name: "Juliette Jeuniaux",
      date: "July 2025",
      position: "Dentist, Belgium",
      picture: Juliette,
      picturesmall: Juliette,
      alt: "Juliette Jeuniaux",
      field: "dentistry",
    },
    {
      key: 19,
      text: "My 2.5-week stay in Arusha, Tanzania, working at Mt. Meru Regional Referral Hospital was an unforgettable experience made possible by HealthMission Africa. It provided valuable insight into practicing medicine in a resource-limited setting. It is the perfect place to gain hands-on experience. With the right mindset, curiosity to learn, and a genuine desire to help, you may quickly find yourself performing FAST scans, placing chest drains, reducing open fractures, resuscitating unstable patients, assisting with intubations, taking part in CPR —which was often a daily task. I particularly enjoyed the night shifts (19:30–07:30), where there were fewer international students and doctors, more responsibility, and a higher volume of trauma cases, most commonly MVAs and animal attacks. A special thank you to Greg and his wonderful team on site for their excellent organization and support throughout the stay. The accommodation was fantastic, and the local food experiences were a highlight of every day. I always felt very safe, and the team ensured that everything was well organized and comfortable throughout my stay. They even helped organize a safari trip once I arrived, as well as an incredible climb up Mt. Meru, the 5th tallest mountain in Africa. I will definitely miss waking up in sunny Arusha, enjoying fresh papaya from the garden and starting the morning with avocado toast before heading to the hospital in a tuk-tuk. Overall, it was an enriching medical and cultural experience that I would highly recommend to anyone interested in global health and meaningful travel. Asante HealthMission Africa, I will be back!!",
      name: "Dr. Maria Furuseth",
      date: "February 2026",
      position: "Internal Medicine resident, Norway",
      picture: Maria,
      picturesmall: Maria,
      alt: "Dr. Maria Furuseth",
      field: "medical",
    },
    {
      key: 20,
      text: "HealthMission Africa provided a unique opportunity to work alongside Tanzanian doctors who manage complex cases every day in a resource-limited setting. It is an incredibly rewarding experience for students, doctors in training, and senior physicians who are passionate about healthcare beyond their own communities. I would highly recommend HealthMission Africa not only for the efficiency of their logistics, but also for their strong relationships with hospital leadership and physicians, as well as their genuine focus on medicine, creating ideal conditions for volunteer doctors. My entire visit was very well organised, with my only disappointment being the brevity of my stay. Can’t wait to return.",
      name: "Dr. Steve Abbey",
      date: "June 2025",
      position: "Obstetrics & Gynecology physician, Australia",
      picture: Steve,
      picturesmall: Steve,
      imagePosition: "top",
      alt: "Dr. Steve Abbey",
      field: "medical",
    },
    {
      key: 21,
      text: "Traveling to Tanzania with Health Mission Africa and volunteering in the emergency department at Mount Meru Hospital was honestly a once-in-a-lifetime experience! I got to handle high-stakes and severe emergencies in challenging conditions, as well as practice important clinical and surgical skills in trauma and end-stage disease patients like suturing, BLS, and bedside procedures. On top of that, I got to enjoy the incredible safari. HealthMission Africa provided a safe environment throughout the trip! Worth it!",
      name: "Iro Ilia",
      date: "July 2024",
      position: "4th year medical student, European University of Cyprus",
      picture: Iro,
      picturesmall: Iro,
      alt: "Iro Ilia",
      imagePosition: "top",
      field: "medical",
    },
    {
      key: 22,
      text: "I came to Tanzania as a third-year dentistry student to participate in the Dentistry Bootcamp organised by HealthMission Africa. I had an amazing experience. The program was very well organised, and the supervision from experienced dentists created a great learning environment. It gave me valuable clinical exposure and helped me develop skills that gave me an edge compared to other third-year dental students. The experience also significantly boosted my confidence even before starting the clinics at university. Highly recommend!",
      name: "Rayhan Sarehane",
      date: "April 2025",
      position: "3rd year dentistry student, European University of Cyprus",
      picture: Rayhan,
      picturesmall: Rayhan,
      alt: "Rayhan Sarehane",
      imagePosition: "center 22%",
      field: "dentistry",
    },
    {
      key: 23,
      text: "Even though I knew my three-week internship in Tanzania would be a great experience, the reality turned out to be even better. Discovering a new culture could be overwhelming at first, but the organization provides such a great support that you settle into the local life so much it’s hard to leave in the end. Time spent at Kaloleni Hospital was an invaluable lesson. Having the chance to try many procedures in an environment completely different from what I am used to back home allowed me to gain so much, not only clinically but also as a person. The experience gives you an opportunity to understand the nature of the local people and learn not only from the staff but from other volunteers from all over the world as well. Tanzania is a remarkable country, home to an incredible diversity of landscapes, wildlife, and rich cultural heritage. I’m very grateful for the experience! Asante sana!",
      name: "Klára Buštová",
      date: "August 2025",
      position: "4th year dentistry student, Charles University, Czech Republic",
      picture: Klara,
      picturesmall: Klara,
      alt: "Klára Buštová",
      field: "dentistry",
    },
    {
      key: 24,
      text: "HealthMission Africa offers an unfiltered, deeply humbling look at medicine in its rawest form. The experience challenges you to think beyond resources and protocols, showing you what it truly means to show up for patients, teaching lessons that stay with you long after you leave and that shape the doctor you become.",
      name: "Jesse Zulberg",
      date: "July 2025",
      position: "5th year medical student, University of Nicosia, Cyprus",
      picture: Jesse,
      picturesmall: Jesse,
      alt: "Jesse Zulberg",
      field: "medical",
    },
    {
      key: 25,
      text: "We completed part of our clinical rotations in Arusha, Tanzania, at Mount Meru Regional Referral Hospital through Health Mission Africa, and it was an outstanding and incredible experience. Greg, the organizer, was exceptional throughout the entire process, always reachable, supportive, and proactive in helping with anything needed, making the experience smooth and comfortable. Clinically, the exposure was invaluable, offering hands-on learning and medical cases that are rarely encountered in more developed healthcare systems, significantly broadening our clinical perspective. The local medical team was exceptional, with special thanks to Dr. Noel, an outstanding physician and teacher. Overall, this was an unforgettable professional and personal experience, and I would absolutely depend on HealthMission Africa again and would love to return in the future.",
      name: "Yannic Leupin",
      date: "October 2025",
      position: "5th year medical student, European University of Cyprus",
      picture: Yannic,
      picturesmall: Yannic,
      alt: "Yannic Leupin",
      field: "medical",
    },
    {
      key: 26,
      text: "I had the opportunity to spend two weeks in Arusha with HealthMission Africa. During this time, I was able to learn alongside local dentists in the city’s hospitals, combining rewarding autonomy with the reassuring presence of experienced practitioners. The same was true during the outreach programs, where we provided free dental care to communities located further outside the city. The collaboration between local dentists, European dentists, and a diverse group of people coming together to treat patients was particularly moving and enriching. In addition to this valuable balance between autonomy and mentorship, the experience also highlighted the importance of providing high-quality and efficient care. We were aware that this might be the last time some of these patients would see a dentist before the next outreach. It was therefore essential for us to provide durable treatments and address all infectious sources. This experience proved to be rich in local discoveries, as well as in professional learning and meaningful experiences.",
      name: "Nathan Toledano",
      date: "July 2025",
      position: "4th year dentistry student, Universidad Europea de Madrid, Spain",
      picture: Nathan,
      picturesmall: Nathan,
      alt: "Nathan Toledano",
      imagePosition: "top",
      field: "dentistry",
    },
    {
      key: 27,
      text: "My volunteering experience in Tanzania was deeply enriching, both on a human and professional level. I worked in a clinical setting and in a day care centre, within an atmosphere of sharing, trust and mutual learning with the local teams, adapting patient care to a limited-resource context.",
      name: "Maria José González Díaz",
      date: "November 2024",
      position: "Physiotherapist, Switzerland",
      picture: Maria2,
      picturesmall: Maria2,
      alt: "Maria José González Díaz",
      field: "physiotherapy",
    },
    {
      key: 28,
      text: "My time in Tanzania with Health Mission Africa was really fulfilling. I had the chance to interact closely with patients as a dental volunteer, and I received significantly more practical clinical experience than I had anticipated. We also took part in outreach projects, which allowed us to treat a huge number of patients in impoverished populations. Every day was an educational experience, both personally and professionally. On top of that, we had the chance to go sightseeing and experience the local culture, which made the trip even more special. I would highly recommend this experience to anyone looking to grow in dentistry while making a meaningful difference.",
      name: "Jad Saad",
      date: "July 2024",
      position: "4th year dentistry student, European University of Cyprus",
      picture: Jad,
      picturesmall: Jad,
      alt: "Jad Saad",
      field: "dentistry",
    },
  ];

  const reviews = allReviews
    .filter((review) => matchesFilter(review, filterField))
    .sort((a, b) => {
      const db = reviewTimestamp(b);
      const da = reviewTimestamp(a);
      if (db !== da) return db - da;
      return b.key - a.key;
    });

  if (reviews.length === 0) {
    return null;
  }

  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const hasMultipleReviews = reviews.length > 1;

  return (
    <Grid item xs={12} className={classes.carouselGrid}>
      <Carousel
        NextIcon={<ArrowForwardIosIcon />}
        PrevIcon={<ArrowBackIosIcon />}
        indicators={isDesktop && hasMultipleReviews}
        navButtonsAlwaysVisible={hasMultipleReviews}
        navButtonsAlwaysInvisible={!hasMultipleReviews}
        navButtonsProps={{
          style: {
            backgroundColor: "transparent",
            color: "grey",
            opacity: hasMultipleReviews ? 1 : 0,
            marginRight: isDesktop ? "200px" : "0px",
            marginLeft: isDesktop ? "200px" : "0px",
          },
        }}
        animation={"slide"}
        duration={500}
        autoPlay={false}
      >
        {reviews.map((review, index) => (
          <CarouselReviewItem carouselItem={review} key={review.key} index={index} />
        ))}
      </Carousel>
    </Grid>
  );
};

export default ReviewsCarousel;
